import { createRouter, createWebHashHistory } from 'vue-router'

import { usePageLoader } from '@/composables/usePageLoader'
import { accountAuthRoutes, accountProtectedRoutes } from '@/modules/account/router'
import { useAuthStore } from '@/modules/account/stores/auth'
import assetsRoutes from '@/modules/assets/router'

const pageLoader = usePageLoader()

const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      component: () => import('@/layout/Base.vue'),
      redirect: '/assets/tanks',
      meta: { requiresAuth: true },
      children: [...accountProtectedRoutes, ...assetsRoutes],
    },
    {
      path: '/auth',
      component: () => import('@/layout/Auth.vue'),
      redirect: '/auth/login',
      children: [...accountAuthRoutes],
    },
  ],
})

router.beforeEach(async (to, from, next) => {
  pageLoader.show()

  const authStore = useAuthStore()
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth === true)

  if (requiresAuth) {
    const isAuthenticated = await authStore.checkAuth()

    if (!isAuthenticated) {
      if (to.name !== 'login') {
        next({ name: 'login' })
      } else {
        next()
      }
      return
    }
  }

  if (to.name === 'login' && authStore.isAuthenticated) {
    next('/')
    return
  }

  next()
})

router.afterEach(() => {
  setTimeout(() => {
    pageLoader.hide()
  }, 300)
})

export default router
